import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { FileUtils } from "../../../../../common/utils/file_utils";
import { IUpdateAssistenciaArquivoDiversoUseCase } from "../../../presentation/useCases/update/update_assistencia_arquivo_diverso_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateAssistenciaArquivoDiversoUseCase
 */

export class UpdateAssistenciaArquivoDiversoUseCase implements IUpdateAssistenciaArquivoDiversoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async updateAssistenciaArquivoDiverso(
    idAssistenciaTecnica: number,
    idAssistenciaArquivo: number,
    descricao: string,
    arquivo: File | null,
    limparArquivo: boolean,
  ): Promise<void> {
    if (limparArquivo === true && arquivo === null) throw new UserFriendlyError("Você deve selecionar um arquivo!");

    if (arquivo !== null) FileUtils.validateFileSize(arquivo);

    await this.repository.updateAssistenciaArquivoDiverso(
      idAssistenciaTecnica,
      idAssistenciaArquivo,
      descricao,
      arquivo,
      limparArquivo,
    );
  }
}
